<template>
  <Teleport to="body">
    <dialog
      class="modal"
      :class="{ 'document-modal': isDocumentContext }"
      v-bind="attrs"
      open
      @keyup.esc="close"
      @mousedown="onBackdropClick"
    >
      <div
        class="modal-content"
        :class="modalWidth"
      >
        <header class="modal-header">
          <slot name="title">
            <h3 class="!text-white">
              {{ title }}
            </h3>
          </slot>

          <FontAwesomeIcon
            class="close-btn close-btn-light"
            :icon="faXmark"
            @click="close"
          />

          <span class="sr-only">Close modal</span>
        </header>

        <section
          v-if="$slots.body"
          class="modal-body"
        >
          <slot name="body" />
        </section>

        <section
          v-if="$slots.footer"
          class="modal-footer"
        >
          <slot name="footer" />
        </section>
      </div>
    </dialog>
  </Teleport>
</template>

<script setup>
import { useAttrs, computed, inject } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';

const isDocumentContext = inject('isDocumentContext', false);

// bind attrs to dialog instead of having teleport auto-inherit them
defineOptions({ inheritAttrs: false });
const attrs = useAttrs();

const props = defineProps({
  disabled: Boolean,
  title: String,
  size: {
    type: String,
    default: '2xl',
  },
});

const emit = defineEmits(['close']);

const close = () => {
  if (!props.disabled) {
    emit('close');
  }
};

const onBackdropClick = e => {
  if (e.target.classList.contains('modal')) {
    close();
  }
};

const modalWidth = computed(() => {
  return `max-w-${props.size}`;
});
</script>
